export enum GameState {
    Idle,
    Betting,
    Started,
    GameResult = 0x7000,
    Shuffle = 0x7fff,
    Restart, //sedie sicbo ReShake & roulette ReSpin
    RoundCancel,
}
